import useIsMobile from "./useIsMobile";
import useIsPc from "./useIsPc";

const useIsTablet = () => {
  const isMobile = useIsMobile();
  const isPC = useIsPc();

  return !isMobile && !isPC;
};

export default useIsTablet;
